import { render, staticRenderFns } from "./hospitaltender.vue?vue&type=template&id=558fa5ea"
import script from "./hospitaltender.vue?vue&type=script&lang=js"
export * from "./hospitaltender.vue?vue&type=script&lang=js"
import style0 from "./hospitaltender.vue?vue&type=style&index=0&id=558fa5ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports